module.exports = __webpack_public_path__ + "static/media/CEO_Desk.a76295b0.mp4";